import { BallBg } from 'components';
import React from 'react';
import { AthleteFocus, Banner, Shoutout } from './components';

const AthleteZone = (props) => {
  return (
    <React.Fragment>
      <BallBg />
      <Banner />
      <Shoutout />
      <AthleteFocus />
      {/*<SocialMedia/>*/}
    </React.Fragment>
  );
};

export default AthleteZone;
